<template>
  <div class="progress-step" :id="`step-${index}`" @click="click" :class="{'disabled': disabled, 'sp-disabled': disabled && index === 3, 'active': active}">
    <div class="progress-step-content">
      <div class="progress-step-content-left">
        <p class="progress-step-title">{{title}}</p>
        <p class="progress-step-status">{{statusText}}</p>
        <p class="progress-step-tip" :class="{'sp-tip': index === 2}" v-if="tip">{{tip}}</p>
      </div>
      <p class="progress-step-num">{{index}}</p>
    </div>
    <div class="progress-step-footer" :class="{'fail': fail}" v-if="showFooter">
      <div class="fail-header" v-if="showFailHeader">
        <p class="fail-header-label">驳回原因</p>
        <p class="fail-header-date">{{failDate}}</p>
      </div>
      <p class="fail-reason" v-if="failInfo">
        {{failInfo}}
      </p>
      <div class="progress-step-info-wrapper" v-if="showIdentity">
        <p class="progress-step-info">
          <span>登录账号</span>
          <span>申请手机号{{mobile}}</span>
        </p>
        <p class="progress-step-info">
          <span>初始密码</span>
          <span>本人身份证后6位</span>
        </p>
      </div>
      <ucar-button v-if="btnText" size="full" @click="btnClick">{{btnText}}</ucar-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    statusText: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 1
    },
    fail: {
      type: Boolean,
      default: false
    },
    showFailHeader: {
      type: Boolean,
      default: false
    },
    failDate: {
      type: String,
      default: ''
    },
    failInfo: {
      type: String,
      default: ''
    },
    showIdentity: {
      type: Boolean,
      default: false
    },
    mobile: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    stress: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showFooter () {
      return this.showFailHeader || this.fail || this.showIdentity || this.btnText
    }
  },
  methods: {
    btnClick () {
      this.$emit('btnClick', this.index)
    },
    click () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../styles/variable.styl';

.progress-step {
  background-color: #fff;
  border-radius: 8px;
  position: relative;

  &.disabled {
    pointer-events: none;
  }

  &.sp-disabled {
    pointer-events: auto;
    .progress-step-content {
      opacity: .5;
      .progress-step-content-left {
        .progress-step-title {
          color: $ucar_font_color;
        }
      }
    }
  }

  &.active {
    .progress-step-content {
      .progress-step-num {
        color: $ucar_main_button;
      }
    }
  }

  .progress-step-content {
    padding: 30px 30px 0;
    display: flex;
    align-items: center;

    .progress-step-content-left {
      height: 146px;
      flex: 1 0 0;
      display: flex;
      flex-flow: column nowrap;
      padding: 10 0;
      min-width: 0;

      p {
        line-height: 1;
      }

      p + p {
        margin-top: 20px;
      }

      .progress-step-title {
        color: $ucar_title_color;
        font-size: $ucar_font_normal;
      }

      .progress-step-status {
        color: $ucar_font_color;
        font-size: $ucar_font_h3;
      }

      .progress-step-tip {
        color: $ucar_font_assist_color;
        font-size: $ucar_font_h5;

        &.sp-tip {
          color: $ucar_title_color;
        }
      }
    }

    .progress-step-num {
      width: 120px;
      font-size: 146px;
      line-height: 1;
      color: $ucar_font_num;
      text-align: right;
    }
  }

  .progress-step-footer {
    padding: 30px;

    &.fail {
      background-color: $ucar_main_bg;

      .fail-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .fail-header-label, .fail-header-date {
          font-size: $ucar_font_normal;
          line-height: 1;
        }

        .fail-header-date {
          color: $ucar_font_assist_color;
        }
      }

      .fail-reason {
        font-size: $ucar_font_normal;
        line-height: 1.5;
      }

      .fail-header + .fail-reason {
        margin-top: 30px;
      }

      .fail-header + .button, .fail-reason + .button {
        margin-top: 30px;
      }
    }
    
    .progress-step-info-wrapper {
      background-color: $ucar_main_bg;
      border-radius: 8px;
      border: 1PX solid $ucar_main_button; /*no*/
      padding: 30px;

      .progress-step-info {
        line-height: 1;
        font-size: $ucar_font_normal;

        span {
          &:first-child {
            margin-right: 50px;
            color: $ucar_title_color;  
          }
        }
      }

      .progress-step-info + .progress-step-info {
        margin-top: 30px;
      }
    }

    .progress-step-info-wrapper + .button {
      margin-top: 30px;
    }
  }
}

.progress-step + .progress-step {
  margin-top: 20px;
}
</style>